function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5669,28.7822L40,37.2153L37.2153,40L28.7822,31.5669C25.7499,33.9928,21.9044,35.4441,17.722,35.4441C7.93947,35.4441,0,27.5046,0,17.722C0,7.93947,7.93947,0,17.722,0C27.5046,0,35.4441,7.93947,35.4441,17.722C35.4441,21.9044,33.9928,25.7499,31.5669,28.7822ZM15.7529,15.7529L9.84557,15.7529L9.84557,19.6911L15.7529,19.6911L15.7529,25.5985L19.6911,25.5985L19.6911,19.6911L25.5985,19.6911L25.5985,15.7529L19.6911,15.7529L19.6911,9.84557L15.7529,9.84557L15.7529,15.7529Z",
    fill: "#F4F4F4",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoomIn.70d921d57ebdaeefba31f79e029f6f4d.svg";
export { ForwardRef as ReactComponent };